import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ETH as ETHAddress, USDC as USDCAddress, USDT as USDTAddress, TBTC as TBTCAddress, WBTC as WBTCAddress, ARB as ARBAddress } from "../../../../constants/addresses";
import { useUpdaterChainId } from "../../../../hooks/web3";
import { useAppDispatch } from "../../../../state/hooks";
import { useBestBuyPair, useBestBuyTokens } from "../../../../state/dex/hooks";
import { updateBestBuyPairToken } from "../../../../state/dex/actions";
import { useModalOpened } from "../../../../state/application/hooks";
import { ApplicationModal } from "../../../../state/application/reducer";
import { TradeDirection } from "../../../Exchange/types";
import { ExchangeBox } from "../../../Layout";
import RateInput from "../RateInput";
import TokenInput from "../TokenInput";
import DateSelect from "../DateSelect";
import BuyAmountInput from "../BuyAmountInput";
import PreviewInfo from "../PreviewInfo";
import TradeButton from "../TradeButton";
import { StyledFormContainer, StyledFormTitle, StyledFormContent, StyledInputTokensWrapper } from "./styled";
import { StyledRowLabel } from "../../styled";

var BestBuyForm = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var expectChainId = useUpdaterChainId();
  var dispatch = useAppDispatch();
  var isPreviewOpen = useModalOpened(ApplicationModal.BEST_BUY_ORDER_PREVIEW);

  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 2),
      inputToken = _useBestBuyPair2[0],
      outputToken = _useBestBuyPair2[1];

  var tokens = useBestBuyTokens(expectChainId); //@notice: 当前只展示 USDT 和 USDC

  var inputTokens = useMemo(() => {
    if (!tokens) {
      return [];
    }

    var usdtAddress = USDTAddress[expectChainId].toLocaleLowerCase();
    var usdcAddress = USDCAddress[expectChainId].toLocaleLowerCase();
    var filteredTokens = Object.values(tokens).filter(token => {
      return [usdtAddress, usdcAddress].includes(token.address.toLocaleLowerCase());
    });
    var usdtIndex = filteredTokens.findIndex(token => token.address.toLocaleLowerCase() === usdtAddress);
    var usdcIndex = filteredTokens.findIndex(token => token.address.toLocaleLowerCase() === usdcAddress);

    if (usdtIndex > -1 && usdcIndex > -1) {
      var _filteredTokens$splic = filteredTokens.splice(usdtIndex, 1),
          _filteredTokens$splic2 = _slicedToArray(_filteredTokens$splic, 1),
          usdt = _filteredTokens$splic2[0];

      filteredTokens.splice(0, 0, usdt);
    }

    return filteredTokens;
  }, [tokens]);
  var outputTokens = useMemo(() => {
    var _TBTCAddress$expectCh, _WBTCAddress$expectCh, _ARBAddress$expectCha;

    var ethAddress = ETHAddress[expectChainId].toLocaleLowerCase();
    var tbtcAddress = (_TBTCAddress$expectCh = TBTCAddress[expectChainId]) === null || _TBTCAddress$expectCh === void 0 ? void 0 : _TBTCAddress$expectCh.toLocaleLowerCase();
    var wbtcAddress = (_WBTCAddress$expectCh = WBTCAddress[expectChainId]) === null || _WBTCAddress$expectCh === void 0 ? void 0 : _WBTCAddress$expectCh.toLocaleLowerCase();
    var arbAddress = (_ARBAddress$expectCha = ARBAddress[expectChainId]) === null || _ARBAddress$expectCha === void 0 ? void 0 : _ARBAddress$expectCha.toLocaleLowerCase();
    return tokens ? Object.values(tokens).filter(token => [ethAddress, tbtcAddress, wbtcAddress, arbAddress].includes(token.address.toLocaleLowerCase())).sort(a => {
      return a.symbol === 'ETH' ? -1 : 1;
    }) : [];
  }, [tokens]);

  var handleSelectToken = params => {
    var token = params.token,
        direction = params.direction;
    dispatch(updateBestBuyPairToken({
      direction,
      token
    }));
  };

  return __jsx(ExchangeBox, {
    className: "".concat(isPreviewOpen && 'hide')
  }, __jsx(StyledFormContainer, null, __jsx(StyledFormTitle, null, t('create_an_order')), __jsx(StyledFormContent, null, __jsx("div", null, __jsx(StyledRowLabel, null, t('sell_token')), __jsx(StyledInputTokensWrapper, null, inputTokens.map(token => {
    return __jsx(TokenInput, {
      key: token.address,
      logo: token.logo,
      symbol: token.symbol,
      isSelected: (inputToken === null || inputToken === void 0 ? void 0 : inputToken.address) === (token === null || token === void 0 ? void 0 : token.address),
      onClick: () => handleSelectToken({
        token,
        direction: TradeDirection.Input
      })
    });
  }))), __jsx("div", null, __jsx(StyledRowLabel, null, t('buy_token')), __jsx(StyledInputTokensWrapper, {
    wrap: true
  }, outputTokens.map(token => {
    return __jsx(TokenInput, {
      key: token.address,
      logo: token.logo,
      symbol: token.symbol,
      isSelected: (outputToken === null || outputToken === void 0 ? void 0 : outputToken.address) === (token === null || token === void 0 ? void 0 : token.address),
      wrap: true,
      onClick: () => handleSelectToken({
        token,
        direction: TradeDirection.Output
      })
    });
  }))), __jsx(RateInput, null), __jsx(BuyAmountInput, null), __jsx(DateSelect, null), __jsx(PreviewInfo, null), __jsx(TradeButton, {
    text: t('preview_order')
  }))));
};

export default BestBuyForm;